// PA-2b draft tool argument validators (service / lead / checklist).

import { nonEmptyString, uuidString } from "./paToolHelpers.js";

export type PaDraftValidationOk = {
  ok: true;
  toolId: "service_request_draft" | "lead_draft" | "checklist_nudge";
  args: Record<string, unknown>;
};
export type PaDraftValidationResult = PaDraftValidationOk | { ok: false; error: string };

export function validateServiceRequestDraft(obj: Record<string, unknown>): PaDraftValidationResult {
  const description = nonEmptyString(obj.description);
  if (!description) return { ok: false, error: "description is required" };
  const queue_id = obj.queue_id != null ? uuidString(obj.queue_id) : null;
  if (obj.queue_id != null && !queue_id) {
    return { ok: false, error: "queue_id must be a valid uuid when provided" };
  }
  return {
    ok: true,
    toolId: "service_request_draft",
    args: {
      description: description.slice(0, 8000),
      location_label:
        typeof obj.location_label === "string" ? obj.location_label.trim().slice(0, 500) : "",
      location_address:
        typeof obj.location_address === "string" ? obj.location_address.trim().slice(0, 1000) : "",
      preferred_timeframe:
        typeof obj.preferred_timeframe === "string"
          ? obj.preferred_timeframe.trim().slice(0, 500)
          : "",
      ...(queue_id ? { queue_id } : {}),
    },
  };
}

export function validateLeadDraft(obj: Record<string, unknown>): PaDraftValidationResult {
  const first_name = nonEmptyString(obj.first_name);
  const last_name = nonEmptyString(obj.last_name);
  const customer_name = nonEmptyString(obj.customer_name);
  const phone = nonEmptyString(obj.phone);
  const contact_query = nonEmptyString(obj.contact_query);
  const existing_lead_id = obj.existing_lead_id != null ? uuidString(obj.existing_lead_id) : null;
  if (obj.existing_lead_id != null && !existing_lead_id) {
    return { ok: false, error: "existing_lead_id must be a valid uuid when provided" };
  }
  const hasIdentity = Boolean(
    customer_name || first_name || last_name || phone || contact_query || existing_lead_id,
  );
  if (!hasIdentity) {
    return {
      ok: false,
      error: "Provide customer_name, name parts, phone, contact_query, or existing_lead_id",
    };
  }
  return {
    ok: true,
    toolId: "lead_draft",
    args: {
      ...(customer_name ? { customer_name: customer_name.slice(0, 200) } : {}),
      ...(first_name ? { first_name: first_name.slice(0, 100) } : {}),
      ...(last_name ? { last_name: last_name.slice(0, 100) } : {}),
      ...(phone ? { phone: phone.slice(0, 40) } : {}),
      ...(nonEmptyString(obj.email) ? { email: nonEmptyString(obj.email)!.slice(0, 200) } : {}),
      ...(nonEmptyString(obj.product_line)
        ? { product_line: nonEmptyString(obj.product_line)!.slice(0, 64) }
        : {}),
      ...(nonEmptyString(obj.size_config)
        ? { size_config: nonEmptyString(obj.size_config)!.slice(0, 100) }
        : {}),
      ...(typeof obj.notes === "string" ? { notes: obj.notes.slice(0, 4000) } : {}),
      ...(contact_query ? { contact_query: contact_query.slice(0, 200) } : {}),
      ...(existing_lead_id ? { existing_lead_id } : {}),
    },
  };
}

